export default __webpack_public_path__ + "static/media/report-black-icon.690c705f.svg";